<form [formGroup]="numberPickerFormGroup" class="flex items-center">
  @if (currencyPicker) {
    <span class="ml-2">{{ currencySymbol }}</span>
  }
  <input
    formControlName="min"
    autofocus
    class="w-[85px] h-min border-none hover:border-none bg-transparent text-xs py-0 px-2"
    id="search-number-min"
    type="number"
    placeholder="Min"
    min="0"
  />
  <span class="mx-2 text-xl">-</span>
  @if (currencyPicker) {
    <span>{{ currencySymbol }}</span>
  }
  <input
    formControlName="max"
    class="w-[85px] h-min border-none hover:border-none bg-transparent text-xs py-0 px-2"
    id="search-number-max"
    type="number"
    placeholder="Max"
    min="0"
  />
  <button
    class="btn-xs"
    [disabled]="
      (!numberPickerFormGroup.controls['min'].value && !numberPickerFormGroup.controls['max'].value) ||
      (!!numberPickerFormGroup.controls['min'].value &&
        !!numberPickerFormGroup.controls['max'].value &&
        numberPickerFormGroup.value.max < numberPickerFormGroup.value.min)
    "
    (click)="emitSelection()"
  >
    Apply
  </button>
</form>
